// ============================================================================
// Main Entry Point
// EduPath Africa v2.0
// ============================================================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Debug logging in development
if (import.meta.env.DEV) {
  console.log('[EduPath] Starting application...');
  console.log('[EduPath] Environment:', import.meta.env.MODE);
  console.log('[EduPath] API URL:', import.meta.env.VITE_API_URL || 'Not configured');
}

// Error boundary for unhandled errors
window.onerror = (message, source, lineno, colno, error) => {
  console.error('[EduPath] Unhandled error:', { message, source, lineno, colno, error });
};

// Unhandled promise rejections
window.onunhandledrejection = (event) => {
  console.error('[EduPath] Unhandled promise rejection:', event.reason);
};

// Mount the application
const root = document.getElementById('root');

if (!root) {
  throw new Error('Root element not found. Ensure there is a <div id="root"></div> in your HTML.');
}

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
